import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '@/shared/utils/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'min-h-[100px] w-full resize-y rounded-sm border bg-surface px-3 py-2 text-sm text-fg shadow-sm',
        'placeholder:text-fg-subtle',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1',
        'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-fg-muted',
        invalid
          ? 'border-danger-strong focus-visible:ring-danger'
          : 'border-border-strong focus-visible:ring-primary',
        className,
      )}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  ),
);

Textarea.displayName = 'Textarea';
